export default __webpack_public_path__ + "static/media/signup-icon-patient.87bd5881.svg";